import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
const routes = {
    path: '',
    component: () =>
      import('../../../layouts/main/Main.vue'),
    children: [
      {
        path: '/backup',
        name: 'backup',
        beforeEnter: (to, from, next) => {
          const bearer = Vue.prototype.$session.get("bearer");
          const hasPermission = localStorage.getItem('systems').includes(to.path);
          const isProjectPlan = Vue.prototype.$session.get("isProject") ? Vue.prototype.$session.get("isProject") : false;
          const bearerDefault = Vue.prototype.$session.get("bearerDefault");
          Vue.prototype.$session.set("bearer", bearerDefault );
          let isAuthenticated = false;
          if (bearer !== null && bearer !== undefined && bearer !== "") {
            isAuthenticated = true;
          } else {
            isAuthenticated = false;
          }
          if (!isAuthenticated)
            if (isProjectPlan) next("/pages/login-horas")
            else next('/pages/login')
          if(hasPermission) next()
          else next('/forbidden')
        },
        component: () =>
          import('./Security/Backup/Backup.vue')
      },
      {
        path: '/user-register',
        name: 'user-register',
        beforeEnter: (to, from, next) => {
          const bearer = Vue.prototype.$session.get("bearer")
          const hasPermission = (localStorage.getItem('systems') || []).includes(to.path)
          const isProjectPlan = Vue.prototype.$session.get("isProject") ? Vue.prototype.$session.get("isProject") : false
          const bearerDefault = Vue.prototype.$session.get("bearerDefault")

          Vue.prototype.$session.set("bearer", bearerDefault )
          
          if (!bearer){
            if (isProjectPlan) {
              next("/pages/login-horas")
            } else {
              next('/pages/login')
            }
          } else if(hasPermission) {
            next()
          } else {
            next('/forbidden')
          }
        },
        component: () =>
          import('./Security/UserRegister/UserRegister.vue')
      },
      {
        path: '/job-register',
        name: 'job-register',
        beforeEnter: (to, from, next) => {
          const bearer = Vue.prototype.$session.get("bearer");
          const hasPermission = localStorage.getItem('systems').includes(to.path);
          const isProjectPlan = Vue.prototype.$session.get("isProject") ? Vue.prototype.$session.get("isProject") : false;
          const bearerDefault = Vue.prototype.$session.get("bearerDefault");
          Vue.prototype.$session.set("bearer", bearerDefault );
          let isAuthenticated = false;
          if (bearer !== null && bearer !== undefined && bearer !== "") {
            isAuthenticated = true;
          } else {
            isAuthenticated = false;
          }
          if (!isAuthenticated)
            if (isProjectPlan) next("/pages/login-horas")
            else next('/pages/login')
          if(hasPermission) next()
          else next('/forbidden')
        },
        component: () =>
        import('./Operation/JobsList/JobRegister/JobRegister.vue')
      },
      {
        path: '/manage-jobs',
        name: 'manage-jobs',
        beforeEnter: (to, from, next) => {
          const bearer = Vue.prototype.$session.get("bearer");
          const hasPermission = localStorage.getItem('systems').includes(to.path);
          const isProjectPlan = Vue.prototype.$session.get("isProject") ? Vue.prototype.$session.get("isProject") : false;
          const bearerDefault = Vue.prototype.$session.get("bearerDefault");
          Vue.prototype.$session.set("bearer", bearerDefault );
          let isAuthenticated = false;
          if (bearer !== null && bearer !== undefined && bearer !== "") {
            isAuthenticated = true;
          } else {
            isAuthenticated = false;
          }
          if (!isAuthenticated)
            if (isProjectPlan) next("/pages/login-horas")
            else next('/pages/login')
          if(hasPermission) next()
          else next('/forbidden')
        },
        component: () =>
        import('./Operation/JobsList/JobsList.vue')

      },
      {
        path: '/job-historic/:id/:name',
        name: 'job-historic',
        beforeEnter: (to, from, next) => {
          const bearer = Vue.prototype.$session.get("bearer");
          const isProjectPlan = Vue.prototype.$session.get("isProject") ? Vue.prototype.$session.get("isProject") : false;
          const bearerDefault = Vue.prototype.$session.get("bearerDefault");
          Vue.prototype.$session.set("bearer", bearerDefault );
          let isAuthenticated = false;
          if (bearer !== null && bearer !== undefined && bearer !== "") {
            isAuthenticated = true;
          } else {
            isAuthenticated = false;
          }
          if (!isAuthenticated)
            if (isProjectPlan) next("/pages/login-horas")
            else next('/pages/login')
          else next()
        },
        component: () =>
        import('./Operation/JobHistoric/JobHistoric.vue')

      },
      {
        path: '/manage-permissions',
        name: 'manage-permissions',
        beforeEnter: (to, from, next) => {
          const bearer = Vue.prototype.$session.get("bearer");
          const hasPermission = localStorage.getItem('systems').includes(to.path);
          const isProjectPlan = Vue.prototype.$session.get("isProject") ? Vue.prototype.$session.get("isProject") : false;
          const bearerDefault = Vue.prototype.$session.get("bearerDefault");
          Vue.prototype.$session.set("bearer", bearerDefault );
          let isAuthenticated = false;
          if (bearer !== null && bearer !== undefined && bearer !== "") {
              isAuthenticated = true;
          } else {
              isAuthenticated = false;
          }
          if (!isAuthenticated)
            if (isProjectPlan) next("/pages/login-horas")
            else next('/pages/login')
          if(hasPermission) next()
          else next('/forbidden')
          },
          component: () =>
            import('./Security/ManagePermissions/ManagePermissions.vue')
      },
      {
        path: '/systems-list',
        name: 'systems-list',
        beforeEnter: (to, from, next) => {
          const bearer = Vue.prototype.$session.get("bearer");
          const hasPermission = localStorage.getItem('systems').includes(to.path);
          const isProjectPlan = Vue.prototype.$session.get("isProject") ? Vue.prototype.$session.get("isProject") : false;
          const bearerDefault = Vue.prototype.$session.get("bearerDefault");
          Vue.prototype.$session.set("bearer", bearerDefault );
          let isAuthenticated = false;
          if (bearer !== null && bearer !== undefined && bearer !== "") {
            isAuthenticated = true;
          } else {
            isAuthenticated = false;
          }
          if (!isAuthenticated)
            if (isProjectPlan) next("/pages/login-horas")
            else next('/pages/login')
          if(hasPermission) next()
          else next('/forbidden')
        },
        component: () =>
          import('./Security/SystemsList/SystemsList.vue')
      },
      {
        path: '/new-system',
        name: 'new-system',
        beforeEnter: (to, from, next) => {
          const bearer = Vue.prototype.$session.get("bearer");
          const bearerDefault = Vue.prototype.$session.get("bearerDefault");
          const isProjectPlan = Vue.prototype.$session.get("isProject") ? Vue.prototype.$session.get("isProject") : false;
          Vue.prototype.$session.set("bearer", bearerDefault);
          let isAuthenticated = false;
          if (bearer !== null && bearer !== undefined && bearer !== "") {
            isAuthenticated = true;
          } else {
            isAuthenticated = false;
          }

          if (!isAuthenticated)
            if (isProjectPlan) next("/pages/login-horas")
            else next('/pages/login')
          else next()
        },
        component: () =>
          import('./Security/SystemsList/NewSystem/NewSystem.vue')
      },
      {
        path: '/system-edit/:id',
        name: 'system-edit',
        beforeEnter: (to, from, next) => {
          const bearer = Vue.prototype.$session.get("bearer");
          const bearerDefault = Vue.prototype.$session.get("bearerDefault");
          const isProjectPlan = Vue.prototype.$session.get("isProject") ? Vue.prototype.$session.get("isProject") : false;
          Vue.prototype.$session.set("bearer", bearerDefault);
          let isAuthenticated = false;
          if (bearer !== null && bearer !== undefined && bearer !== "") {
            isAuthenticated = true;
          } else {
            isAuthenticated = false;
          }
          if (!isAuthenticated)
            if (isProjectPlan) next("/pages/login-horas")
            else next('/pages/login')
          else next()
        },
        component: () =>
          import('./Security/SystemsList/EditSystem/EditSystem.vue')
      }, 
      {
        path: 'manager-users/:id',
        name: 'edit-person',
        beforeEnter: (to, from, next) => {
          const bearer = Vue.prototype.$session.get("bearer");
          const bearerDefault = Vue.prototype.$session.get("bearerDefault");
          const isProjectPlan = Vue.prototype.$session.get("isProject") ? Vue.prototype.$session.get("isProject") : false;
          Vue.prototype.$session.set("bearer", bearerDefault);
          let isAuthenticated = false;
          if (bearer !== null && bearer !== undefined && bearer !== "") {
            isAuthenticated = true;
          } else {
            isAuthenticated = false;
          }
          if (!isAuthenticated)
            if (isProjectPlan) next("/pages/login-horas")
            else next('/pages/login')
          else next()
        },
        component: () =>
          import('./Security/ManagePermissions/EditUserPermissions/EditUserPermissions.vue')
      },
      {
        path: '/product-backlog',
        name: 'product-backlog',
        beforeEnter: (to, from, next) => {
            const bearer = Vue.prototype.$session.get("bearer");
            const hasPermission = localStorage.getItem('systems').includes(to.path);
            console.log(hasPermission);
            const isProjectPlan = Vue.prototype.$session.get("isProject") ? Vue.prototype.$session.get("isProject") : false;
            const bearerDefault = Vue.prototype.$session.get("bearerDefault");
            Vue.prototype.$session.set("bearer", bearerDefault );
            let isAuthenticated = false;
            if (bearer !== null && bearer !== undefined && bearer !== "") {
                isAuthenticated = true;
            } else {
                isAuthenticated = false;
            }
            if (!isAuthenticated)
              if (isProjectPlan) next("/pages/login-horas")
              else next('/pages/login')
            if(hasPermission) next()
            else next('/forbidden')
        },
        component: () =>
            import('./ProductBacklog/ProductBacklog.vue')
      },
    ]
}

export default [
  routes
]

